import { KText } from '@/ui-library/components';
import { Box, Flex, Icon, Tooltip } from '@chakra-ui/react';
import { XClose } from '@kula-ai/icons/solid/XClose';
import moment from 'moment-timezone';
import { useKFlags } from '@/hooks/use-k-flags';
import {
  OVERRIDE_TYPE,
  hasOverride,
} from '@/components/shared/interview-scheduler/SchedulerDetails/overrideType.constants';

export const SelfFreeSlot: React.FC<{
  eventInfo: any;
  removeSlot?: (id: string) => void;
  timezone: string;
}> = ({ eventInfo, removeSlot = () => {}, timezone }) => {
  const { event, backgroundColor, textColor } = eventInfo || {};
  const { feOverrideType } = useKFlags();

  const startTime = moment(event?.start).tz(timezone).format('hh:mm A');

  const { startStr, endStr } = eventInfo?.event || {};
  const minutes = moment(endStr)
    .tz(timezone)
    .diff(moment(startStr).tz(timezone), 'minutes');

  // Check if this is a custom slot using override_type or is_custom flag
  const isCustomSlot = feOverrideType
    ? hasOverride(event?.override_type ?? OVERRIDE_TYPE.NONE)
    : event?.is_custom === true;

  let padding = '6px';

  if (minutes <= 15) {
    padding = '0px 2px';
  } else if (minutes <= 30) {
    padding = '4px';
  }

  const content = (
    <Box
      w="100%"
      h="100%"
      p={padding}
      overflow="hidden"
      bg={backgroundColor}
      minW={0}
    >
      <Flex justifyContent="space-between" w="100%" alignItems="center">
        <KText
          variant="small_text"
          whiteSpace="nowrap"
          isTruncated
          enableTooltip
          color={textColor}
        >
          {startTime}
        </KText>
        <Icon
          as={XClose}
          cursor="pointer"
          onClick={() => {
            removeSlot(event.id);
          }}
        />
      </Flex>
    </Box>
  );

  return isCustomSlot ? (
    <Tooltip label="Custom slot" placement="top" hasArrow>
      {content}
    </Tooltip>
  ) : (
    <>{content}</>
  );
};
